export default {
  how_to_place_order: {
    header: 'Miten teen tilauksen?',
    body: 'Selaa valikkoa, lisää tuotteita ostoskoriin ja seuraa kassavaiheita. Saat vahvistuksen, kun tilaus on tehty.',
  },
  schedule_order: {
    header: 'Voinko ajastaa tilauksen etukäteen?',
    body: 'Kyllä! Valitse kassalla "Ajasta"-vaihtoehto asettaaksesi sinulle sopivan noutoajan.',
  },
  customize_order: {
    header: 'Voinko muokata tilaustani?',
    body: 'Ehdottomasti. Napauta valikon tuotetta nähdäksesi muokkausvaihtoehdot, kuten täytteet, lisukkeet ja mieltymykset.',
  },
  track_order: {
    header: 'Miten seuraan tilaustani?',
    body: 'Tilauksen tekemisen jälkeen näet reaaliaikaisia päivityksiä sovelluksessa — vahvistuksesta valmisteluun ja noutovalmiuteen.',
  },
  cancel_or_edit_order: {
    header: 'Voinko perua tai muokata tilaustani sen tekemisen jälkeen?',
    body: 'Jos tilauksesi valmistelua ei ole vielä aloitettu, voit pyytää muutoksia soittamalla ravintolaan suoraan sovelluksen kautta.',
  },
  payment_methods: {
    header: 'Mitä maksutapoja hyväksytte?',
    body: 'Hyväksymme yleisimmät luotto- ja pankkikortit, Apple Payn ja Google Payn laitteestasi riippuen.',
  },
  no_confirmation: {
    header: 'En saanut vahvistusta. Mitä minun pitäisi tehdä?',
    body: 'Tarkista sähköpostisi roskapostikansio tai käy sovelluksen Tilaukset-välilehdellä. Jos et silti näe sitä, ota yhteyttä suoraan ravintolaan.',
  },
  pickup_instructions: {
    header: 'Mistä noudan tilaukseni?',
    body: 'Noutoohjeet näkyvät vahvistusnäytöllä ja tilauksen yhteenvedossa. Etsi kylttejä tai kysy henkilökunnalta saapuessasi.',
  },
  loyalty_points: {
    header: 'Voinko ansaita kanta-asiakaspisteitä tilauksistani?',
    body: 'Kyllä, kelvolliset ostot keräävät pisteitä automaattisesti. Voit tarkastella saldoasi ja palkintojasi sovelluksen päänäytöllä.',
  },
  apply_promo_code: {
    header: 'Miten käytän alennuskoodia tai alennusta?',
    body: 'Kassalla näet vaihtoehdon syöttää alennuskoodi. Saatavilla olevat alennukset otetaan myös käyttöön automaattisesti, jos olet oikeutettu niihin.',
  },
  issue_with_order: {
    header: 'Mitä teen, jos tilauksessani on ongelma?',
    body: 'Olemme täällä auttamassa. Ota yhteyttä ravintolaan sovelluksen kautta tai lähetä sähköpostia tuelle suoraan Ota yhteyttä tukeen -vaihtoehdon kautta.',
  },
  use_loyalty_and_coupon: {
    header: 'Voinko käyttää kanta-asiakaspisteitä ja kuponkia (kuten osta 1 saa 1 ilmaiseksi) samassa tilauksessa?',
    body: 'Ei — vain yksi alennus tai tarjous voidaan käyttää tilausta kohden. Tämä varmistaa palkintojen ja tarjousten oikeudenmukaisen käytön. Valitse vaihtoehto, joka tarjoaa sinulle parhaan hyödyn!',
  },
};
